import {
  AUDIENCE_TYPES,
  AUDIENCE_TYPES_ARRAY,
  getAudienceSlug,
} from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import Artifact from "./Artifact";
import CompareModal from "./CompareModal";
import { getAudienceEmoji } from "posts/constants";

function NewsSitesCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);

  const renderContent = (audience, small) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-tough-cookies-news-fox.png"
              imageAlt="Fox News logo"
              title="Fox News"
              subtitle="foxnews.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.foxnews.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-news-cnn.png"
              imageAlt="CNN logo"
              title="CNN"
              subtitle="cnn.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.cnn.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-news-cbs.png"
              imageAlt="CBS News logo"
              title="CBS"
              subtitle="cbsnews.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="http://www.cbsnews.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
          </>
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-dont-tread-news-nextnews.png"
              imageAlt="Next News Network logo"
              title="Next News Network"
              subtitle="youtube.com/c/nextnewsnetwork"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.youtube.com/c/NextNewsNetwork/featured"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-dont-tread-news-oneamericanews.png"
              imageAlt="One America News logo"
              title="One America News"
              subtitle="oann.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.oann.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-dont-tread-news-wsj.png"
              imageAlt="Wall Street Journal logo"
              title="Wall Street Journal"
              subtitle="wsj.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://wsj.com"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
          </>
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-peoplepower-news-nyt.png"
              imageAlt="New York Times logo"
              title="New York Times"
              subtitle="nytimes.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.nytimes.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-news-cnn.png"
              imageAlt="CNN logo"
              title="CNN"
              subtitle="cnn.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.cnn.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-peoplepower-news-forbes.png"
              imageAlt="Forbes logo"
              title="Forbes"
              subtitle="forbes.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.forbes.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
          </>
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-news-crunchyroll.png"
              imageAlt="Crunchyroll logo"
              title="Crunchyroll"
              subtitle="crunchyroll.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.crunchyroll.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-news-ign.png"
              imageAlt="IGN logo"
              title="IGN"
              subtitle="ign.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.ign.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-news-breakfastclub.png"
              imageAlt="The Breakfast Club radio show poster"
              title="The Breakfast Club Power 105.1 FM"
              subtitle="power105.iheart.com"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://power1051.iheart.com/"
              small={small}
              wordBreak={small ? "break-all" : "break-word"}
            />
          </>
        );
    }
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        News Sites
      </CardTitle>
      {renderContent(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>
            Compare Audiences – News Sites
          </CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`voices-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderContent(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default NewsSitesCard;
